// extracted by mini-css-extract-plugin
module.exports = {"projectCardDetailsList":"ProjectCardDetailsList_projectCardDetailsList__1_Oir"};